import cn from 'classnames'
import { LoadingOutlined } from '@ant-design/icons'

export const Loader = ({ itemsLength }: { itemsLength: number }) => {
  return (
    <div
      className={cn('infinite-list__sentry', {
        'infinite-list__sentry--fill': !itemsLength
      })}
    >
      <LoadingOutlined className="chat-list-feature-list__spinner" spin />
    </div>
  )
}
